import { WarehouseSyncEvent } from '../des.dto';
import { IssueRemoteService } from './remote/issue-remote.service';
import { AssetRemoteService } from './remote/asset-remote.service';
import { InspectionRemoteService } from './remote/inspection-remote.service';
import { IssueMediaRemoteService } from './remote/issue-media-remote.service';
import { logger, ASSETS_STORE, INSPECTIONS_STORE, ISSUE_MEDIAS_STORE, ISSUES_STORE, NOTES_STORE, OUTLINES_STORE, SAVED_SEARCH_STORE, SYSTEM2DS_STORE, TEXTS_STORE } from '@damofire/data-commons';
import { Injectable } from '@angular/core';
import { NoteRemoteService } from './remote/note-remote.service';
import { SavedSearchRemoteService } from './remote/saved-search-remote.service';
import { SystemRemoteService } from './remote/system-remote.service';
import { WarehouseOutlineRemoteService } from './remote/warehouse-outline-remote.service';
import { LayoutTextRemoteService } from './remote/layout-text-remote.service';

@Injectable()
export class OutputSyncService {
  constructor(
    private readonly issueRemoteService: IssueRemoteService,
    private readonly issueMediaRemoteService: IssueMediaRemoteService,
    private readonly assetRemoteService: AssetRemoteService,
    private readonly inspectionRemoteService: InspectionRemoteService,
    private readonly noteRemoteService: NoteRemoteService,
    private readonly savedSearchRemoteService: SavedSearchRemoteService,
    private readonly systemRemoteService: SystemRemoteService,
    private readonly warehouseOutlineRemoteService: WarehouseOutlineRemoteService,
    private readonly layoutTextRemoteService: LayoutTextRemoteService,
  ) {}

  async handleOutputChanges(event: WarehouseSyncEvent): Promise<void> {
    switch (event.store) {
      case ISSUES_STORE:
        await this.issueRemoteService.saveAll(event);
        break;
      case ISSUE_MEDIAS_STORE:
        await this.issueMediaRemoteService.saveAll(event);
        break;
      case ASSETS_STORE:
        await this.assetRemoteService.saveAll(event);
        break;
      case INSPECTIONS_STORE:
        await this.inspectionRemoteService.saveAll(event);
        break;
      case NOTES_STORE:
        await this.noteRemoteService.saveAll(event);
        break;
      case SAVED_SEARCH_STORE:
        await this.savedSearchRemoteService.saveAll(event);
        break;
      case SYSTEM2DS_STORE:
        await this.systemRemoteService.saveAll(event);
        break;
      case OUTLINES_STORE:
        await this.warehouseOutlineRemoteService.saveAll(event);
        break;
      case TEXTS_STORE:
        await this.layoutTextRemoteService.saveAll(event);
        break;
      default:
        logger.info('No offline operation supported for events.', { store: event.store, division: event.division, category: 'sync' });
    }
  }
}
